import { render, staticRenderFns } from "./sdk.vue?vue&type=template&id=5c34c62a&scoped=true"
import script from "./sdk.vue?vue&type=script&lang=js"
export * from "./sdk.vue?vue&type=script&lang=js"
import style0 from "./sdk.vue?vue&type=style&index=0&id=5c34c62a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c34c62a",
  null
  
)

export default component.exports